import template from './home.html';
import controller from './home.controller';


import './home.styl';

let homeComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default homeComponent;



// WEBPACK FOOTER //
// ./client/app/components/home/home.component.js